import { useEffect, useState } from 'react';
import { getCachedImage, setCachedImage } from '../lib/dexie/helpers';
import { logError } from '../lib/firebase/logs';

export default function useImageCache(url, fallback = '/images/capa-template.jpg') {
    const [src, setSrc] = useState(fallback);

    useEffect(() => {
        let isMounted = true;
        let objectUrl;

        const loadImage = async () => {
            if (!url || url === fallback) {
                if (isMounted) setSrc(fallback);
                return;
            }
            const cached = await getCachedImage(url);
            if (cached) {
                objectUrl = URL.createObjectURL(cached);
                if (isMounted) setSrc(objectUrl);
                return;
            }
            if (typeof navigator !== 'undefined' && !navigator.onLine) return;
            try {
                const response = await fetch(url);
                const blob = await response.blob();
                await setCachedImage(url, blob);
                objectUrl = URL.createObjectURL(blob);
                if (isMounted) setSrc(objectUrl);
            } catch (err) {
                logError(err, { function: 'useImageCache', url, message: 'Erro ao carregar imagem ou salvar no Dexie.' });
            }
        };

        loadImage();

        return () => {
            isMounted = false;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [url, fallback]);

    return src;
}